// src/components/Common/ErrorBoundary.js
import React, { Component } from 'react';
import { Alert, Button } from '@mui/material';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            حدث خطأ غير متوقع. الرجاء المحاولة مرة أخرى.
          </Alert>
          <Button variant="contained" onClick={this.handleRetry}>
            إعادة المحاولة
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;